import { BASE_URL } from "@/constants/config";
import { request, downloadFile } from "@/utils/request";

export const CAPTAIN_DATA_ENDPOINTS = {
  base: `${BASE_URL}api/captain-data-exports/`,
  detail: (id) => `${CAPTAIN_DATA_ENDPOINTS.base}${encodeURIComponent(id)}/`,
  download: (id) => `${CAPTAIN_DATA_ENDPOINTS.base}download/${encodeURIComponent(id)}/`,
};

class CaptainDataExport {
  async removeFile(id) {
    return await request({
      url: CAPTAIN_DATA_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }

  async downloadFile(id, filename) {
    return await downloadFile({
      fileName: filename,
      downloadURL: CAPTAIN_DATA_ENDPOINTS.download(id),
    });
  }
}

export const CaptainDataService = new CaptainDataExport();
